export default __webpack_public_path__ + "static/media/logo_light.0f73878a.png";